import {Card, CardBody} from '@resurs/tron-react';
import {FormattedMessage} from 'react-intl';
import '../../styles/general-styles.css';

const Error = () => (
  <div className="container container--fixed px-8">
    <Card className="small bg-white border-danger rounded-0">
      <CardBody className="danger-box">
        <h6>
          <FormattedMessage
            id="ErrorContainer.header"
            defaultMessage="An error occurred"
          />
        </h6>
        <p>
          <FormattedMessage
            id="ErrorContainer.info"
            defaultMessage="Please try again"
          />
        </p>
      </CardBody>
    </Card>
  </div>
);

export default Error;
